export default __webpack_public_path__ + "static/media/revit_classification_thumbnail.9aeda15d.png";